import * as Yup from 'yup';
import {LoginFormData} from "../../lib/types/types";

export const validationSchema: Yup.SchemaOf<LoginFormData> =  Yup.object({
    username: Yup.string().required("Моля въведете Потребителско име"),
    password: Yup.string().required("Моля въведете Парола"),
})

